module.exports = __webpack_public_path__ + "v4assets/kentik-kube-2023-shopping-no-header.d9a22e0957c4afa32a83f9a218f17fc2.png";